import axios from 'axios'
import { Message } from 'element-ui';

let baseUrl = process.env.VUE_APP_API_BASE_URL

const http = axios.create({
    withCredentials: true,
    baseURL: baseUrl,
    timeout: 100000     // 超时时间
});

// 添加请求拦截器
// 在发送请求之前先处理一下数据
http.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
// 在接到响应数据后，先处理一下，比如处理非200的状态
http.interceptors.response.use(function (response) {
    if(response.data && response.data.msg === '错误: token已经过期') {
        Message.error({
            message: response.data.msg, onClose: () => {
                location.replace('/#/login')
            }
        })
    }
    // 在处理响应之前做些什么
    return response;
}, function (error) {
    // 对请求错误做些什么
    if (error.name === 'AxiosError') {
        Message.error({
            message: error.message, onClose: () => {
                location.replace('/#/login')
            }
        })
        return new Promise(() => { });
    }
    return Promise.reject(error);
});

export default http
